// extracted by mini-css-extract-plugin
export default {"button":"CartDisplay_button__fDfRu","icon":"CartDisplay_icon__ACeDb","badge":"CartDisplay_badge__Q7jvc","bump":"CartDisplay_bump__zqMXf"};